import { makeVar } from "react-reactive-var";
import { isElectronRunning } from "../../App";

const ENABLE_KEY = "tf_debug_electron_chrome";
const PLATFORM_KEY = "tf_debug_electron_chrome_platform";

const readStoredEnabled = () =>
  typeof localStorage !== "undefined" &&
  localStorage.getItem(ENABLE_KEY) === "1";

const readStoredPlatform = () =>
  (typeof localStorage !== "undefined" &&
    localStorage.getItem(PLATFORM_KEY)) ||
  "darwin";

export const forcedElectronChrome = makeVar(readStoredEnabled());
export const forcedElectronChromePlatform = makeVar(readStoredPlatform());

export const isElectronChrome = () =>
  isElectronRunning() || forcedElectronChrome();

export const getForcedChromePlatform = () => forcedElectronChromePlatform();

export const setElectronChrome = (on, platform = "darwin") => {
  forcedElectronChrome(!!on);
  forcedElectronChromePlatform(platform);
  try {
    if (on) {
      localStorage.setItem(ENABLE_KEY, "1");
      localStorage.setItem(PLATFORM_KEY, platform);
    } else {
      localStorage.removeItem(ENABLE_KEY);
      localStorage.removeItem(PLATFORM_KEY);
    }
  } catch (e) {}
  console.log(`[DEBUG] Electron chrome ${on ? "ON" : "OFF"} (${platform})`);
};

if (typeof window !== "undefined") {
  window.__tfElectronChrome = setElectronChrome;
  // URL override for quick preview/testing: ?tfElectronChrome=darwin|win32|linux|off
  try {
    const qp = new URLSearchParams(window.location.search).get(
      "tfElectronChrome",
    );
    if (qp === "off") setElectronChrome(false);
    else if (qp === "darwin" || qp === "win32" || qp === "linux")
      setElectronChrome(true, qp);
  } catch (e) {}
}
